
//MIKE kaching - price fix script on PDP, plus discount label for kaching bundles.
    //for other codes: reports back CustomEvent("priceVarChanged", { detail: price }) that rely on price.
      console.log("PDP templ");
        function waitForElement(selector, callback) {
          const element = document.querySelector(selector);
          if (element) {
            callback(element);
          } else {
            setTimeout(() => waitForElement(selector, callback), 100); // Retry after 100ms
          } 
        }

        function parsePrice(priceStr) {
  const cleaned = priceStr.replace(/[^0-9.,]/g, '').replace(',', '.');
  return parseFloat(cleaned) || 0;
}
      
        waitForElement('.kaching-bundles__bars .kaching-bundles__bar:last-of-type', (element) => {
          console.log("kaching bundle found - exeucting script");
            const kparent = document.querySelector(".kaching-bundles__bars");
            if (!kparent) return;
            if (kparent) {
              let debounceTimer;
              const logSelectedPrice = () => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                  const selected_salepr = kparent.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
                  const selected_comparepr = kparent.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-full-price');
                  if (selected_salepr) {
                    price = selected_salepr.textContent.trim();
                    window.kachingprice = price;
                    document.dispatchEvent(new CustomEvent("priceVarChanged", { detail: price }));

                    console.log('Selected price:', selected_salepr.textContent.trim());
                        const mainPriceEl = document.querySelector(".price__container .price__sale .price-item--sale");
                        if (mainPriceEl) {
                          mainPriceEl.textContent = price;
                        }

                        price_forlabel = parsePrice(price);
                  } else {
                    console.log('No bundle selected');
                  }

                  if (selected_comparepr){
                     comp_price = selected_comparepr.textContent.trim();
                     console.log('Selected compare price:', selected_comparepr.textContent.trim());
                          const mainPriceEl = document.querySelector(".price__container .price__sale .price-item--regular");
                          if (mainPriceEl) {
                            mainPriceEl.textContent = comp_price;
                        }
                      comparePrice_forlabel = parsePrice(comp_price);
                  }

                  if (selected_comparepr && selected_salepr){
                  const percentSaved = ((1 - price_forlabel / comparePrice_forlabel) * 100).toFixed(0);
                  console.log('Percentage saved:', percentSaved + '%');
                  // display, experimental label for kaching!
                  let saveEl = document.querySelector(".badge.price__badge-sale");
                  if (saveEl) saveEl.textContent = `${percentSaved}% Off`;
                  
                  }

                }, 100); // small delay lets DOM update
              };

              //initial
              logSelectedPrice();
              //change
              kparent.addEventListener('input', logSelectedPrice);
              kparent.addEventListener('click', logSelectedPrice);

              //sub selection.
                waitForElement('.kaching-bundles__subscriptions .kaching-bundles__bar:last-of-type', (element) => {
                  const ksubscr = element.closest(".kaching-bundles__subscriptions")
                  ksubscr.addEventListener('input', logSelectedPrice);
                  ksubscr.addEventListener('click', logSelectedPrice);
                    });
              //note: subscription selection?

            }
          console.log("Bundle PDP templ");
});  


//ATC btn price logic for non kaching products (pending)?